<template>
  <div class="modal_dim on">
    <!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal w50p">
          <div class="modal_head">
            <h1 class="h1">
              <span>자격 확인</span>
            </h1>
          </div>
          <div class="modal_con">
            <div class="modal_txt">
              <div class="inform_box">
                <ol class="dot li_space">
                  <li class="small color">
                    <span class="ol_li_txt">
                      외식산업 관련분야 5년 이상 종사자 중, (사)한국외식산업협회 또는 지정 기관의 외식경영관리사 1급 교육과정을 이수한 자
                    </span>
                  </li>
                  <li class="small color">
                    <span class="ol_li_txt">
                      대학 외식관련학과 재학 이상의 학력자로 응시일 기준 85학점 또는 5학기 이상을 이수한 자 중,
                      (사)한국외식산업협회 또는 지정기관의 외식경영관리사 1급교육과정을 이수한 자
                    </span>
                  </li>
                  <li class="small color">
                    <span class="ol_li_txt">
                      (사)한국외식산업협회의 외식경영관리사 2급 자격을 취득 후, 외식산업관련 분야에서 2년 이상을 근무한 자 중,
                      (사)한국외식산업협회 또는 지정기관의 외식경영관리사1급 교육과정을 이수한 자
                    </span>
                  </li>
                  <li class="small color">
                    <span class="ol_li_txt">
                      외식산업 관련 분야 6개월 이상 종사자 중, (사)한국외식산업협회 또는 지정기관의 외식경영관리사 2급 교육과정을 이수한 자
                    </span>
                  </li>
                  <li class="small color">
                    <span class="ol_li_txt">
                      전문대학 외식관련학와 재학 이상의 학력자로 응시일 기준 15학점 또는 1학기 이상을 이수한 자 중,
                      (사)한국외식산업협회 또는 지정기관의 외식경영관리사 2급 교육과정을 이수한 자
                    </span>
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn" @click="$emit('eventClose')">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-exam-cert-popup',
  props: {
    data: {
      type: [Array, Object],
      default: () => {}
    },
    callBack: {
      type: [Function]
    }
  }
}
</script>

<style scoped></style>
